export default __webpack_public_path__ + "static/fa-regular-400-c3b7902dbb40004346b404ca9b507e3f.woff";